<div class="layout-container">
    <div class="layout-content bg-surface-100 dark:bg-surface-900">
        @if (showSplash()) {
            <app-splash-screen (done)="onSplashDone()" />
        } @else {
            <div class="scroller-content"
                 [class.bottom-scroller-content]="showBottomBar()">
                <router-outlet />
            </div>

            @if (showBottomBar()) {
                <nav class="absolute bottom-0 start-0 end-0 z-10 flex justify-center pt-2 pb-3 pointer-events-none">
                    <div class="pointer-events-auto inline-flex items-center gap-1 p-1.5 rounded-full
                                bg-surface-100 shadow-[0_4px_12px_rgba(0,0,0,0.15)] dark:bg-black/90
                                shadow-2xl shadow-black/40
                                ring-1 ring-white/5
                                backdrop-blur-sm">
                        @for (item of navItems; track item.key) {
                            @let active = selectedRoute() === item.key;
                            <a [routerLink]="item.route"
                               class="group flex items-center justify-center gap-2 h-11 rounded-full overflow-hidden
                                      transition-all duration-300 ease-out
                                      active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300"
                               [class]="active
                                    ? 'px-4 bg-primary-500 text-white shadow-lg shadow-primary-500/30'
                                    : 'w-11 text-surface-700 dark:text-surface-300 hover:text-surface-800 dark:hover:text-surface-200 hover:bg-surface-100 dark:hover:bg-surface-800'">
                                <i [class]="'fa-jelly ' + item.icon"
                                   class="text-lg shrink-0 transition-transform duration-300 ease-out group-hover:scale-110"></i>
                                <span class="whitespace-nowrap text-sm font-medium
                                             transition-[max-width,opacity] duration-300 ease-out"
                                      [class]="active ? 'max-w-32 opacity-100' : 'max-w-0 opacity-0'">
                                    {{ item.labelKey | transloco }}
                                </span>
                            </a>
                        }
                    </div>
                </nav>
            }
        }
    </div>
</div>
<c-confirm-dialog key="confirmDialog" />
<c-toast position="bottom-left"></c-toast>
